import { useEffect } from 'react';
import { useCountdown } from 'hooks/useCountdown';

interface Props {
  restExpiredTime: number;
}

export const CountdownExpiredTime = ({ restExpiredTime }: Props) => {
  if (!restExpiredTime) return null;

  const [count, { startCountdown }] = useCountdown({ countStart: restExpiredTime, countStop: 0, intervalMs: 1000 });

  const days = Math.floor(count / 60 / 60 / 24).toString();
  const hours = Math.floor((count / 60 / 60) % 24)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((count / 60) % 60)
    .toString()
    .padStart(2, '0');
  const seconds = Math.floor(count % 60)
    .toString()
    .padStart(2, '0');

  useEffect(() => {
    startCountdown();
  }, []);

  useEffect(() => {
    if (count === 0) {
      location.reload();
    }
  }, [count]);

  return (
    <>
      Còn {days} ngày, {hours}:{minutes}:{seconds}
    </>
  );
};

